export default __webpack_public_path__ + "static/media/satelite.2b6c580c.png";